import { render } from "./ControlsPosition.vue?vue&type=template&id=1221dbbb"
import script from "./ControlsPosition.vue?vue&type=script&lang=js"
export * from "./ControlsPosition.vue?vue&type=script&lang=js"
script.render = render

export default script